import request from '@/utils/request'

/**
 * 分页获取拍卖会车辆列表
 * @param {*} params
 */
export function getCarList(params) {
    return request({
        url: '/front/auction/nlr/getAuctionInfoAndCarListPage',
        method: 'get',
        params
    })
}


/**
 * 各种拍卖倒计时调用
 */
export function updateCarStatus(data) {
    return request({
        url: 'front/auction/updateCarStatus',
        method: 'POST',
        data
    })
}

/**
 * 修改车辆状态 auctionStatus
 * 0未开始 1进行中 2已结束 3流拍（针对于普通与专场拍卖）
 */
export function updateAuctionStatus(data) {
    return request({
        url: 'front/auction/updateAuctionStatus',
        method: 'POST',
        data
    })
}


/**
 * 获取服务器当前时间
 */
export function getCurrentTime() {
    return request({
        url: '/front/auction/getCurrentTime',
        method: 'get'
    })
}